/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { SearchSpecifyUserAction, UpdateAdminUserAction } from '../../../redux/actions/user';
import { UPDATE_ADMIN_USER_RESET, RESEND_EMAIL_USER_RESET } from '../../../redux/constantes/user';

import { ContainerForm } from '../../../components/Containers';
import InputUser from '../../../components/User/InputUser';
import SelectEdit from '../../../components/User/SelectEdit';
import { WrapperListCompanies } from '../../../components/User/WrapperListCompanies';
import CompanyOption from '../../../components/User/CompanyOption';
import { WrapperActiveAndAdmin } from '../../../components/User/WrapperActiveAndAdmin';
import ActiveAndEmail from '../../../components/User/ActiveAndEmail';
import { WrapperButtons } from '../../../components/WrapperButtons';
import ButtonSend from '../../../components/ButtonSend';
import { MessageBoxAlert, MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox';
import AccessMode from '../../../components/User/AccessMode';
import HiringMode from '../../../components/User/HiringMode';
import SelectCreateSincroniza from '../../../components/User/SelectCreateSincroniza';
import AccessModeSincroniza from '../../../components/User/AccessModeSincroniza';
import HeaderTitle from '../../../components/HeaderTitle';
import ButtonReSendEmail from '../../../components/ButtonReSendEmail';

export default function TemplateAdminUserEdit({ userId }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [companiesName, setCompaniesName] = useState([]);
  const [companiesId, setCompaniesId] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [accessMode, setAccessMode] = useState('');
  const [hiringMode, setHiringMode] = useState('');
  const [CPF, setCPF] = useState('');
  const [CNPJ, setCNPJ] = useState('');
  const [nameCompany, setNameCompany] = useState('');
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [accessModeError, setAccessModeError] = useState(false);

  const { searchSpecifyUser, error: errorSearchSpecifyUser } = useSelector((state) => state.searchSpecifyUser);
  const { success: successUpdate, error: errorUpdate } = useSelector((state) => state.updateAdminUser);
  const { success: successResendEmail, error: errorResendEmail } = useSelector((state) => state.resendEmailUser);
  const { userInfo } = useSelector((state) => state.userSign);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(hiringMode);
  }, [hiringMode]);

  useEffect(() => {
    if (errorSearchSpecifyUser === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorSearchSpecifyUser]);

  useEffect(() => {
    if (!searchSpecifyUser) {
      dispatch(SearchSpecifyUserAction(userId));
    } else {
      setName(searchSpecifyUser.name);
      setEmail(searchSpecifyUser.email);
      setIsActive(searchSpecifyUser.isActive);
      setAccessMode(searchSpecifyUser.accessMode);
      setConfirmEmail(searchSpecifyUser.confirmEmail);
      setHiringMode(searchSpecifyUser.contract);
      setCPF(searchSpecifyUser.cpf);
      setCNPJ(searchSpecifyUser.cnpj);
      setNameCompany(searchSpecifyUser.companyName);
      searchSpecifyUser.company.forEach((comp) => {
        setCompaniesName((e) => [...e, { name: comp.companyId.name }]);
        setCompaniesId((e) => [...e, { companyId: comp.companyId._id }]);
      });
    }
  }, [dispatch, searchSpecifyUser, userId]);

  useEffect(() => {
    if (successUpdate) {
      setTimeout(() => {
        dispatch({ type: UPDATE_ADMIN_USER_RESET });
        document.location.href = '/pessoas-cadastradas';
      }, 2000);
    }
    if (successResendEmail) {
      setTimeout(() => {
        dispatch({ type: RESEND_EMAIL_USER_RESET });
      }, 2000);
    }
    if (errorUpdate) {
      setTimeout(() => {
        dispatch({ type: UPDATE_ADMIN_USER_RESET });
      }, 3000);
    }
    if (errorResendEmail) {
      setTimeout(() => {
        dispatch({ type: RESEND_EMAIL_USER_RESET });
      }, 3000);
    }
  }, [dispatch, successUpdate, errorUpdate, successResendEmail, errorResendEmail]);

  const handleSubmit = () => {
    if (accessMode === '') {
      setAccessModeError(true);
      setTimeout(() => {
        setAccessModeError(false);
      }, 3000);
      return;
    }
    dispatch(
      UpdateAdminUserAction(
        userId,
        name,
        email,
        accessMode,
        isActive,
        confirmEmail,
        hiringMode,
        CPF,
        CNPJ,
        nameCompany,
        companiesId,
      ),
    );
  };

  return (
    <ContainerForm>
      {userInfo !== null && (
        <section>
          <HeaderTitle text="Editar Cadastro do Usuário" linkIcon="/images/icons/user-stroke.svg" />
          <InputUser
            label="Nome"
            type="text"
            onChange={(e) => setName(e.target.value)}
            value={name}
            placeholder="Digite o nome completo"
          />
          <InputUser
            label="E-mail"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            placeholder="exemplo@email.com"
          />
          <HiringMode
            setHiringMode={setHiringMode}
            hiringMode={hiringMode}
            setCPF={setCPF}
            CPF={CPF}
            setNameCompany={setNameCompany}
            nameCompany={nameCompany}
            setCNPJ={setCNPJ}
            CNPJ={CNPJ}
          />
          {userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS && (
            <SelectEdit
              companiesName={companiesName}
              setCompaniesName={setCompaniesName}
              setCompaniesId={setCompaniesId}
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && (
            <SelectCreateSincroniza
              companiesName={companiesName}
              setCompaniesName={setCompaniesName}
              setCompaniesId={setCompaniesId}
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS && (
            <SelectCreateSincroniza
              companiesName={companiesName}
              setCompaniesName={setCompaniesName}
              setCompaniesId={setCompaniesId}
            />
          )}
          <WrapperListCompanies>
            {companiesName.map((comp, index) => {
              return (
                <CompanyOption
                  key={index + 1}
                  comp={comp}
                  index={index}
                  companiesName={companiesName}
                  companiesId={companiesId}
                  setCompaniesName={setCompaniesName}
                  setCompaniesId={setCompaniesId}
                />
              );
            })}
          </WrapperListCompanies>
          {userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS && (
            <AccessMode
              value={accessMode}
              modifyFunction={setAccessMode}
              labelText="Escolha o modo de acesso do Usuário:"
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && (
            <AccessModeSincroniza
              value={accessMode}
              modifyFunction={setAccessMode}
              labelText="Escolha o modo de acesso do Usuário:"
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS && (
            <AccessModeSincroniza
              value={accessMode}
              modifyFunction={setAccessMode}
              labelText="Escolha o modo de acesso do Usuário:"
            />
          )}
          <WrapperActiveAndAdmin>
            <ActiveAndEmail validate={false} option={confirmEmail} labelText="Usuário confirmou o email?" />
            <ActiveAndEmail
              validate={true}
              option={isActive}
              modifyFunction={setIsActive}
              labelText="Usuário esta ativo?"
            />
          </WrapperActiveAndAdmin>
          <WrapperButtons>
            {userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS && <a href="/pessoas-cadastradas">Voltar</a>}
            {userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && (
              <a href="/pessoas-cadastradas">Voltar</a>
            )}
            {userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS && (
              <a href="/buscar/pessoas-cadastradas">Voltar</a>
            )}
            {!confirmEmail && <ButtonReSendEmail email={email} />}
            {userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && (
              <ButtonSend
                disabled={accessMode === process.env.REACT_APP_DEV_ACCESS ? true : false}
                onClick={handleSubmit}
              >
                Atualizar
              </ButtonSend>
            )}
            {userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS && (
              <ButtonSend
                disabled={accessMode === process.env.REACT_APP_DEV_ACCESS ? true : false}
                onClick={handleSubmit}
              >
                Atualizar
              </ButtonSend>
            )}
            {userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS && (
              <ButtonSend onClick={handleSubmit}>Atualizar</ButtonSend>
            )}
          </WrapperButtons>
        </section>
      )}
      {successUpdate && <MessageBoxSuccess>Usuário atualizado com sucesso!</MessageBoxSuccess>}
      {successResendEmail && <MessageBoxSuccess>Email re-enviado com sucesso!</MessageBoxSuccess>}
      {errorSearchSpecifyUser && <MessageBoxError>{errorSearchSpecifyUser}</MessageBoxError>}
      {errorUpdate && <MessageBoxError>{errorUpdate}</MessageBoxError>}
      {errorResendEmail && <MessageBoxError>{errorResendEmail}</MessageBoxError>}
      {accessModeError && <MessageBoxAlert>Ops... Você deve escolher o modo de acesso do usuário.</MessageBoxAlert>}
    </ContainerForm>
  );
}
